import { render, staticRenderFns } from "./InvoiceDistributionChart.vue?vue&type=template&id=70324633&scoped=true&"
import script from "./InvoiceDistributionChart.vue?vue&type=script&lang=js&"
export * from "./InvoiceDistributionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70324633",
  null
  
)

export default component.exports